<script setup>
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { useDateHelper, formatLocalized } from "@/composables/useDateHelper";
  import { useSpotStore } from "@/stores/SpotStore";
  import { useCompleteReportStore } from '@/stores/CompleteReportStore';
  
  const dateHelper = useDateHelper();

  const spotStore = useSpotStore();
  const completeReportStore = useCompleteReportStore();

  const { t } = useI18n();

  const apiData = computed(() => spotStore.stationApiDataValues);
  
  const timestamp = computed(() => {
    if (!apiData.value.timestamp) return t('common.notAvailable');

    const localTimezone = spotStore.localTimezoneShort ?  ` ${spotStore.localTimezoneShort}` : '';
    let lastUpdateTimestamp = t('common.notAvailable');

    try {
      if (completeReportStore.lastUpdateTime === 'timestamp') {
        lastUpdateTimestamp = `${formatLocalized(new Date(apiData.value.timestamp), 'd LLL p')}${localTimezone}`
      } else {
        const isoTimestamp = dateHelper.datetimeToISOFormat(apiData.value.timestamp, spotStore.localUTCOffset);

        if (!isoTimestamp) throw 'Invalid date';

        lastUpdateTimestamp = dateHelper.timeFromNow(isoTimestamp);
      }
    } catch (e) {
      console.warn('Error parsing timestamp: ', apiData.value.timestamp, e);
    }

    return lastUpdateTimestamp;
  });
</script>

<template>
  <div>
    <p class="jwx-complete-report__last-update">{{ t('common.lastUpdate') }} <span v-html="timestamp" class="jwx-complete-report__last-update-time"></span></p>
  </div>
</template>